import { render, staticRenderFns } from "./HomePostPanel.vue?vue&type=template&id=ffb03754&scoped=true&lang=pug&"
import script from "./HomePostPanel.vue?vue&type=script&lang=js&"
export * from "./HomePostPanel.vue?vue&type=script&lang=js&"
import style0 from "./HomePostPanel.vue?vue&type=style&index=0&id=ffb03754&lang=scss&scoped=true&"
import style1 from "./HomePostPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb03754",
  null
  
)

export default component.exports